export const getProjectIdFromPath = currentPath => (currentPath.startsWith('/project/P') ? currentPath.match(/\d+/g)[0] : null);

export const getConnectProjectIDFromPath = currentPath =>
	currentPath.startsWith('/connected/X') ? currentPath.match(/\d+/g)[0] : null;
